import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormatMatchResult } from '../../../interfaces/format-match-result.interface';
import { CodelistTranslationService } from '../../../services/codelist-translation.service';

@Component({
    selector: 'app-technical-details-dialog',
    templateUrl: './technical-details-dialog.component.html',
    styleUrls: ['./technical-details-dialog.component.scss'],
    standalone: false
})
export class TechnicalDetailsDialogComponent {

  document: any | undefined;
  format?: FormatMatchResult;

  constructor(
    public dialogRef: MatDialogRef<TechnicalDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private result: any | undefined,
    private codelistTranslationService: CodelistTranslationService
  ) {
    if (result) {
      this.document = result.model;
      this.format = result.format;
    }
  }

  getFormatAsString(): string {
    if (this.format) {
      return `${this.format.name} ${this.format.version} ${this.format.syntax}`;
    }
    return '';
  }

  get erechnungPrefix(): string {
    return this.codelistTranslationService.erechnungPrefix;
  }
}

